module.exports = __webpack_public_path__ + "logo-white.f998af6122a83ff6b22a.png";